module.exports = {
    "collapse": `Strni`,
    "expand": `Raz\u{161}iri`
};


//# sourceMappingURL=sl-SI.main.js.map
